// A JSON document's value space, for a Service API field that carries
// free-form JSON. Typed with this rather than `unknown` so a reader knows
// every value is plain data — no functions, dates, or class instances. Like
// every `.json<T>()` response shape it is declared, not validated: readers
// still check the type of each field they use.
export type JSONValue =
  | string
  | number
  | boolean
  | null
  | JSONValue[]
  | { [key: string]: JSONValue }

// The merchandising JSON object a Store product carries in its
// display_metadata field (GLOSSARY.md "Display metadata").
export type DisplayMetadata = Record<string, JSONValue>

// null covers every way of having no metadata — the field absent, null, or
// anything that is not a plain object (an array, a number, or a JSON string
// the server should have sent as an object). What that means is each
// collection's call: a main product without metadata cannot render its hero
// banner and is omitted; a daily pick simply has no optional fields to read.
export function readDisplayMetadata(raw: unknown): DisplayMetadata | null {
  return isRecord(raw) ? (raw as DisplayMetadata) : null
}

// A plain JSON object — not null, not an array: the one guard every reader
// of a free-form Service API field narrows with before touching a key.
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}
